import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { PlayerService } from '../../services/player.service';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'sd-clap',
    templateUrl: './clap.component.html',
    styleUrls: ['./clap.component.scss']
})

export class ClapComponent implements OnInit {

    @Input() data: any;
    for: String = '';
    from: String = '';
    slug = '';
    clapsCount: number = 0;
    totalClapsCount: number = 0;
    clapsCountIncrement: number = 0;
    myData=[];
    clapLoading: Boolean = false;
    clapAnimationEffect: Boolean = false;
    multipleClaps: any;

    activityId = 0;

    guideStep = 1;

    localClapGuide: Boolean = false;

    constructor(
        private api: ApiService,
        public user: UserService,
        public dialog: DialogService,
        public player: PlayerService,
        public global: GlobalService
    ) {
        const angularthis = this;
        if (localStorage.getItem('clap_guide')) {
            angularthis.localClapGuide = JSON.parse(localStorage.getItem('clap_guide'));
        }
    }

    ngOnInit() {
        this.for = this.data.for;
        this.from = this.data.from;
        this.slug = this.data.slug;
        this.clapsCount = this.data.clapsCount;
        const angularthis = this;
        if (angularthis.from == 'player') {
            setInterval(function () {
                if (angularthis.player.playlist.length > 0 && angularthis.player.myPlaylist != undefined && angularthis.player.myPlaylist != null) {
                    angularthis.clapsCount = angularthis.player.playlist[angularthis.player.myPlaylist.current].clapsCount;
                    angularthis.totalClapsCount = angularthis.player.playlist[angularthis.player.myPlaylist.current].totalClapsCount;
                }
            }, 1000);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue
            this.for = this.data.for;
            this.from = this.data.from;
            this.slug = this.data.slug;
            this.clapsCount = this.data.clapsCount;
            this.totalClapsCount = this.data.totalClapsCount;
        }
    }

    onRightClick(event) {
        // console.log(event);
        return false;
    }

    mouseDown(event) {
        // console.log(event);
        this.clapAnimation();
        this.global.trackEvent('total-clap', this.for + ' ' + this.from + ' clap', this.slug);

        if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
            this.clapsCount = this.player.playlist[this.player.myPlaylist.current].clapsCount;
            this.totalClapsCount = this.player.playlist[this.player.myPlaylist.current].totalClapsCount;
            // console.log('totalClapsCount: ', this.totalClapsCount);
        }
        // console.log(this.clapsCount);
        // console.log(this.totalClapsCount);

        if (this.clapsCount < 51) {
            const angularThis = this;
            this.multipleClaps = setInterval(function () {
                angularThis.clapAnimation();
                if (angularThis.clapsCount >= 50) {
                    clearInterval(angularThis.multipleClaps);
                }
            }, 250);
        }
    }
    mouseUp(event) {
        const angularThis = this;
        clearInterval(angularThis.multipleClaps);
    }

    clapAnimation() {
        if (this.clapsCount < 51) {
            this.clapsCount++;
            this.clapsCountIncrement++;
            this.totalClapsCount++;

            if (this.clapsCount > 50) {
                this.clapsCount = 50;
                this.totalClapsCount--;
            }
            // console.log(this.clapsCount);
            // console.log(this.totalClapsCount);

            if (this.from == 'player') {
                this.player.clapsCount = this.clapsCount;
                this.player.totalClapsCount = this.totalClapsCount;

                if (this.player.clapsCount > 50) {
                    this.player.clapsCount = 50;
                    this.player.totalClapsCount--;
                }
            }
        }

        if (!this.clapLoading && this.clapsCount < 51) {
            this.clap(this.clapsCountIncrement);
        }

        if (this.global.isBrowser) {
            $('.clapAnimations').css('transform', 'rotateZ(' + this.getRandomInt(0, 359) + 'deg)');
        }

        this.clapAnimationEffect = true;

        const angularThis = this;
        setTimeout(function () {
            angularThis.clapAnimationEffect = false;
        }, 1000);
    }

    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    clap(clapsCountIncrement) {
        const angularThis = this;

        if (this.from == 'player') {
            this.slug = this.player.currentSlug;
            // console.log('Clapped from player: ' + this.slug);
        }

        this.clapLoading = true;

       /* if (this.for == 'song') {
            this.api.likeSong(this.slug, 'like', clapsCountIncrement, this.activityId).subscribe(res => {
                this.clapLoading = false;
                this.clapsCountIncrement = this.clapsCountIncrement - clapsCountIncrement;
                // console.log(res);
                this.activityId = res.id;
                this.clapsCount = res.user_like_count;
                this.totalClapsCount = res.total_like_count;

                //if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
                    this.player.clapsCount = this.clapsCount;
                    this.player.totalClapsCount = this.totalClapsCount;
                    this.player.playlist[this.player.myPlaylist.current].clapsCount = this.clapsCount;
                    this.player.playlist[this.player.myPlaylist.current].totalClapsCount = this.totalClapsCount;
               // }

                // console.log('Total Claps: ' + angularThis.totalClapsCount);
                if (angularThis.global.isBrowser) {
                    $('.clapsCountTotal_' + this.slug).html(angularThis.totalClapsCount.toString());
                }
            },
                (err: HttpErrorResponse) => {
                    this.clapLoading = false;
                    if (err.error instanceof Error) {
                        // console.log('Client-side error occured!');
                    } else {
                        // console.log('Server-side error occured!', err);
                    }
                });
        } else if (this.for == 'album') {
            this.api.likeAlbum(this.slug, 'like', clapsCountIncrement, this.activityId).subscribe(res => {
                this.clapLoading = false;
                this.clapsCountIncrement = this.clapsCountIncrement - clapsCountIncrement;
                // console.log(res);
                this.activityId = res.id;
                this.clapsCount = res.user_like_count;
                this.totalClapsCount = res.total_like_count;

                if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
                    this.player.clapsCount = this.clapsCount;
                    this.player.totalClapsCount = this.totalClapsCount;
                    this.player.playlist[this.player.myPlaylist.current].clapsCount = this.clapsCount;
                    this.player.playlist[this.player.myPlaylist.current].totalClapsCount = this.totalClapsCount;
                }

                // console.log('Total Claps: ' + angularThis.totalClapsCount);
                if (angularThis.global.isBrowser) {
                    $('.clapsCountTotal_' + this.slug).html(angularThis.totalClapsCount.toString());
                }
            },
                (err: HttpErrorResponse) => {
                    this.clapLoading = false;
                    if (err.error instanceof Error) {
                        // console.log('Client-side error occured!');
                    } else {
                        // console.log('Server-side error occured!', err);
                    }
                });
        } else if (this.for == 'playlist') {
            this.api.likePlaylist(this.slug, 'like', clapsCountIncrement, this.activityId).subscribe(res => {
                this.clapLoading = false;
                this.clapsCountIncrement = this.clapsCountIncrement - clapsCountIncrement;
                // console.log(res);
                this.activityId = res.id;
                this.clapsCount = res.user_like_count;
                this.totalClapsCount = res.total_like_count;

                if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
                    this.player.clapsCount = this.clapsCount;
                    this.player.totalClapsCount = this.totalClapsCount;
                    this.player.playlist[this.player.myPlaylist.current].clapsCount = this.clapsCount;
                    this.player.playlist[this.player.myPlaylist.current].totalClapsCount = this.totalClapsCount;
                }

                // console.log('Total Claps: ' + angularThis.totalClapsCount);
                if (angularThis.global.isBrowser) {
                    $('.clapsCountTotal_' + this.slug).html(angularThis.totalClapsCount.toString());
                }
            },
                (err: HttpErrorResponse) => {
                    this.clapLoading = false;
                    if (err.error instanceof Error) {
                        // console.log('Client-side error occured!');
                    } else {
                        // console.log('Server-side error occured!', err);
                    }
                });
        } else if (this.for == 'video') {
            this.api.likeVideo(this.slug, 'like', clapsCountIncrement, this.activityId).subscribe(res => {
                this.clapLoading = false;
                this.clapsCountIncrement = this.clapsCountIncrement - clapsCountIncrement;
                // console.log(res);
                this.activityId = res.id;
                this.clapsCount = res.user_like_count;
                this.totalClapsCount = res.total_like_count;

                if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
                    this.player.clapsCount = this.clapsCount;
                    this.player.totalClapsCount = this.totalClapsCount;
                    this.player.playlist[this.player.myPlaylist.current].clapsCount = this.clapsCount;
                    this.player.playlist[this.player.myPlaylist.current].totalClapsCount = this.totalClapsCount;
                }

                // console.log('Total Claps: ' + angularThis.totalClapsCount);
                if (angularThis.global.isBrowser) {
                    $('.clapsCountTotal_' + this.slug).html(angularThis.totalClapsCount.toString());
                }
            },
                (err: HttpErrorResponse) => {
                    this.clapLoading = false;
                    if (err.error instanceof Error) {
                        // console.log('Client-side error occured!');
                    } else {
                        // console.log('Server-side error occured!', err);
                    }
                });
        } */
    }

    removeGuide() {
        if (this.from == 'player' && !this.global.guides.claps) {
            if (this.guideStep == 1) {
                this.guideStep = 2;
            } else {
                this.global.guides.claps = true;
                this.api.updateScreenGuide('claps');
            }
        }
    }
}
